var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2316.94 2243.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_3",
    "data-name": "\\xA1\\xC2\\xC1\\u02DA\\xCF\\u02C7\\xCC\\xCC\\u02DA\\xC8 \\u201E\\uF8FF\\u2021\\u2030\\xCB\\xC2\\xCC\\xDA 3",
    x1: 995.82,
    y1: 583.97,
    x2: 1188.94,
    y2: 583.97,
    gradientTransform: "translate(1368.97 2166.17) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfefea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfe3ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_3-2",
    x1: 1415.8,
    y1: 2335.99,
    x2: 1597.03,
    y2: 2335.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2",
    "data-name": "\\xA1\\xC2\\xC1\\u02DA\\xCF\\u02C7\\xCC\\xCC\\u02DA\\xC8 \\u201E\\uF8FF\\u2021\\u2030\\xCB\\xC2\\xCC\\xDA 2",
    x1: 2093.8,
    y1: 811.96,
    x2: 2255.06,
    y2: 811.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfe3ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-2",
    x1: 2093.8,
    y1: 860.73,
    x2: 2223.84,
    y2: 860.73,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-3",
    x1: 537.7,
    y1: 561.4,
    x2: 737.09,
    y2: 561.4,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-4",
    x1: 496.98,
    y1: 566.85,
    x2: 735.81,
    y2: 566.85,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M684.68,959.07v99.54H830.51v137.82h-4.6V2206c0,79,64.66,143.68,143.68,143.68h0c12.52,0,774.92.7,774.92.7V1190c0-127.56-103.41-231-231-231Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#afd8c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.21,1151.1v-92.32c0-57.55,47.09-104.72,104.63-104.83,79,0,143.69,64.12,143.69,142.49v54.66Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1008.98,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1092.24,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1185.91,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1269.18,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1359.96,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1443.23,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1536.9,
    width: 495.89,
    height: 20.82,
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.91,
    y: 1620.16,
    width: 495.89,
    height: 20.81,
    fill: "#01888b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1781.59,2350.35H1011.51s155.66-32,103.78-224h819.79S1987,2350.35,1781.59,2350.35Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1923,908.49l160.9,58s5.65-53.32,24-89.15c6.92-13.54,20.11-22.93,35-26.07,193.42-40.75,196-167.28,196-167.28s35.15-149-162.48-235.8c-210.7-92.57-266.93,104.1-266.93,104.1s-48.33,103.29,37.63,216.2c12.3,16.16,16.16,37.22,11.65,57C1947.41,875.17,1923,908.49,1923,908.49Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084,966.05l-20.76,57.63c-7.77,21.59-28.24,34.18-45.48,28l-98-35.28c-17.24-6.21-25-29-17.21-50.55l20.76-57.64Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1813.25 840.96 1792.69 863.3 1731.76 841.36 1727.93 810.23 1813.25 840.96",
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2177,710.66c40.87-36.74-11.15-81-50.84-60.06-7.19,3.79-12.26,10.62-15.17,18.21-5.14,13.43-12.54,34.57-12.54,34.57a253.77,253.77,0,0,1-23.12-14.92c5.06-12.94,9.78-26.49,10.05-39.09,1.22-56-76.82-40.49-52.35,8.66,5.73,11.51,16.35,22.4,28.62,31.93l-83.26,237.51,11,4,51.18-146,26.55-75.76c1.39-4,3-8.13,4.72-12.38a199.29,199.29,0,0,0,22.66,13.08L2012,939.56l11,4,82.21-228.3c2.18.9,4.42,1.87,6.48,2.61C2132.58,725.31,2159.42,726.48,2177,710.66Zm-111.93-29.91c-13.64-10.74-31.77-29.12-28.24-45.31a12.63,12.63,0,0,1,7.67-8.74c36-14.57,28.12,32.28,26,37.73A145.77,145.77,0,0,1,2065.09,680.75ZM2168.3,705.4c-19.09,13.92-40.76,12-60.6,2.83l12.64-35.1a25.85,25.85,0,0,1,13.43-14.78c11.24-5.19,29.1-8.49,44,7.3C2186.68,677,2181.27,695.94,2168.3,705.4Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1984.72,334.77a9,9,0,0,0,4.33-12l-52-110.5a9,9,0,0,0-16.37,7.7l52,110.5A9,9,0,0,0,1984.72,334.77Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343.32,463.92a9,9,0,0,1,4.34-12l110.49-52a9,9,0,0,1,7.7,16.37l-110.49,52A9,9,0,0,1,2343.32,463.92Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200.47,378.79a9,9,0,0,0,11.57-5.44l41.38-114.89a9,9,0,1,0-17-6.13L2195,367.22A9,9,0,0,0,2200.47,378.79Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1872.37,1013.09,1418.19,2247c15.67,47.14,3.8,55.55,30.15,65.25l82.92-8.44c26.34,9.7,58.48,36.24,68.17,9.89l454.28-1234.22Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.37,1013.09,1418.19,2247c-9.69,26.34,68.3,79.29,68.3,79.29l471.78-1281.77Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910,1057.94l85.84,31.59a50.82,50.82,0,0,0,65.26-30.14l35.1-95.37a50.82,50.82,0,0,0-30.14-65.26l-47.69-17.55h0l-38.15-14A50.81,50.81,0,0,0,1915,897.31l-35.11,95.38A50.82,50.82,0,0,0,1910,1057.94Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#053c5e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1917.37,
    y: 977.17,
    width: 71.16,
    height: 193.12,
    transform: "translate(76.32 2328.56) rotate(-69.79)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1278.52 2211.37 1248.2 2243.38 1246.65 2197.87 1265.73 2190.86 1278.52 2211.37",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.06,2404.92a41.3,41.3,0,0,1,15.57,2.53c.49.18.95.43,1.43.63a42.22,42.22,0,0,1,8.06,4.38c.16.11.3.23.45.34,1.07.77,2.11,1.57,3.09,2.42a43.09,43.09,0,0,1,3.28,3.2L1597,2320.26l-94-34.59-87.26-32.12Z",
    transform: "translate(-194.41 -207.05)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_3-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M944.58,2165.41C929.16,2275.74,946,2390,946,2389.05s12.3,0,12.3,0,17-134.11,21-178.87,0-47.75,0-47.75S960,2055.09,944.58,2165.41Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f39f85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "746.12 1673.68 708.39 1697.73 692.47 1664.58 741.22 1608.71 746.12 1673.68",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "945.22 1452.76 899.04 1573.45 869.54 1551.5 935.44 1440.4 945.22 1452.76",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1142.32,1618.84a19,19,0,0,0-6.8,11.76l-5.66,16.85,1.79,3.17,8,9.19a12.1,12.1,0,0,1,3.15-6.31l12.56-14.06s20.62-24,1.38-32.19c11.29-22.33,3.21-21.76,3.21-21.76l-10.11,19.13Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.21,1623.24s-4.16-3.92-.46-13.23-1.9-8.67-1.9-8.67-15.42,36.32-10.47,40.45S1145.21,1623.24,1145.21,1623.24Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1007.25,1805.3l13.83,1.08,47-54.77,25.38,28.89A767.8,767.8,0,0,1,1036.1,1870c-1.94,9.25-12,102.36-12,102.36H942.59s13-68.32-9.94-106.35S1007.25,1805.3,1007.25,1805.3Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.55,2165.41C965.12,2275.74,982,2390,982,2389.05s12.3,0,12.3,0,17.05-134.11,21.05-178.87,0-47.75,0-47.75S996,2055.09,980.55,2165.41Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.22,1720.1l-46.94,16.43,4.63,35c.07.5.2,1,.29,1.46.9.16,1.81.33,2.7.55l.44.13.42.08c10.83,2.66,18.5,11.61,21.94,22a55.34,55.34,0,0,0,20.32-.26c4.59-1,8.75-2.39,10.66-4.6C1034.59,1769.28,1010.22,1720.1,1010.22,1720.1Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.43,1749.6c-4.24,8.45-5,18.42-1,27,6.38,13.5,5.82,28.66,1.57,37-2.9,5.67-10.47,11.33-17.19,15.52a26.53,26.53,0,0,0-12.47,20.09c-1,11.39-2.12,25.38-11.89,28.74-28.32,9.76-38.71,8.82-42.48-14.79a47.89,47.89,0,0,1,2.44-23.13,41.37,41.37,0,0,0-.87-31c-2.84-6.47-5.35-13.59-5.35-18.5,0-5.35,4.9-12.88,10-19.3a39.66,39.66,0,0,0,8.34-28.43c-.91-10.22.52-23.28,10.89-32.13,19.35-16.51,62.31,9.48,62.31,9.48S1019.94,1732.62,1011.43,1749.6Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.88,1871.62l-18.12,18.76c-12,12.46-15.76,29.81-1.29,39.34l59.21,47-5.45,10.19a24.86,24.86,0,0,0,2.17,26.78l6.26,8.2,13.85-47.55-42.93-53.6a10.29,10.29,0,0,1,2.22-16h0Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.07,1972.33s11.94,31,11.94,62.32c0,17.23-14.93,147.18-14.93,147.18H943.51c5.26-96-23.83-107.74-23.83-149.22,0-29.26,22.91-60.28,22.91-60.28Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#053c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946,2374.61s-6.78,5.33-5.53,12.13,3,22.71,3,22.71h7l-.21-14.84c0-1,15,14.84,17.48,14.84h36.91s2.45-10-19.22-13.23S946,2374.61,946,2374.61Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.45,2374.61s-6.79,5.33-5.54,12.13,3,22.71,3,22.71h7l-.21-14.84c0-1,15,14.84,17.49,14.84h36.9s2.45-10-19.22-13.23S985.45,2374.61,985.45,2374.61Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#12375a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.53,2165.41",
    transform: "translate(-194.41 -207.05)",
    fill: "#01888b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632.74,2380.07s5.07,7,29,13.1c5.26,1.34,10.93,2.25,10.93,10.93H649l-24.11-4.17v4.17h-13s-3.63-21.3,4-24Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,2364.77l-1.24,15.3h0a14.77,14.77,0,0,1-16,.54l-.89-.54v-15.3Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.77,2383.12s5.07,7,29,13.1c5.26,1.34,10.93,2.25,10.93,10.93H528.08L504,2403v4.17h-13s-3.62-21.3,4-24Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,2367.82l-1.24,15.3h0a14.74,14.74,0,0,1-16,.53l-.89-.53v-15.3Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M643.59,1988.78l-5.87,384.29h-28s-42.62-310.26-33.52-384.29S643.59,1988.78,643.59,1988.78Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,1988.7s-9.74,118-32.13,183.4-62.81,201-62.81,201h-29s48.39-283.41,37.32-384.37H614Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#053c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.22,1793.1s34.51,80.47,43.27,80.47c7,0-2.63-65.71-2.63-65.71h28.9s36.34,112.62,7.44,133.2-92.39-58.24-92.39-58.24Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.33,1998.92l10.46,25.85c5,10.16,23.54,10.42,35.83,7.19a2.56,2.56,0,0,0,1.21-4.19c-6.75-7.4-24.26-26.37-30.33-30.61Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.66,1776.29c11.28.1,22,5.69,27.78,15.39a21.92,21.92,0,0,1,3.4,11v186H536.24V1814.82s2.16-38.66,40-38.66C592.29,1776.16,603.31,1776.22,610.66,1776.29Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.67 1781.73 445.67 1614.7 449.17 1614.82 449.17 1781.73 445.67 1781.73",
    fill: "#f6a505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,1740.67l11.26,42.39s9.62,7.81,22.35,4.43,10.29-12.56,10.29-12.56l-7.21-27.17-20.15.09Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f39f85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.49,1755.38c3.89-1.16,7.35-2.77,8.8-5,6.52-21-19.26-66.17-19.26-66.17L563,1702.49l7.33,32.9a28.3,28.3,0,0,0,16.22,19.73h0A45.33,45.33,0,0,0,612.49,1755.38Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.49,1698.22a90.64,90.64,0,0,0,27.94-7.43c13.65-6.35.29-19.7.29-19.7s-9.32,7.66-28.9,9.88c-13.22,1.49-17.29-.07-24.29,6.45-9.51,8.85-1.51,28.16-1.51,28.16l17.36,40.75,2.29-.61s-6.13-25.34-8.41-33.92c1.36-4.54,4-5.23,6.22-4.79a6.64,6.64,0,0,1,4.94,4.92l11.69,44s31.22,4.64,37.77.56-6.88-35.42-6.88-35.42a13.55,13.55,0,0,0-13.64,7.44c-4.43,8.75-14,3.43-14,3.43Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.21,1807.86l-1-5.55c-2.25-12.29-14-27.57-25.83-31.58H664.1l3.8,26.21,17.31,10.92Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.63,1716.85c3.07-1.09,6.9,1.12,8.54,4.94s.47,7.81-2.61,8.91-6.9-1.11-8.54-4.94S566.55,1718,569.63,1716.85Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,1794l23.9,13.83s-15-.15-15.24,0l-25.3-21.17s1.84-3.69,7.57-.57A29.11,29.11,0,0,1,673,1794Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.48,1787.8s-59.69,66.32-59.69,106.06,48.45,109.81,48.45,109.81l23.94-7s-21.6-86.69-21.6-109.75S583,1830,583,1830",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.33,1886.91c0,19.85,17.57,92.45,21.7,109.36-1.21.32-1.71.41-3.54.89-5.08-20.89-21.66-90.74-21.66-110.25,0-23.66,43.22-56.87,45-58.27l2.13,2.79C583.57,1831.76,540.33,1865,540.33,1886.91Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f6a505"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M657.33,1754.4s-1.69,26.11,16.61,44.6a7,7,0,0,0,4.74,1.91c3.72,0,6.12-1.57,8-2.38a7.7,7.7,0,0,0,4.51-4.18,3.32,3.32,0,0,0-.78-3.39c-3.79-4.36-15.7-19.47-13-34.5C668.17,1750.73,657.33,1754.4,657.33,1754.4Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.78,1797.36a5.06,5.06,0,0,0,2.44-3,3.32,3.32,0,0,0-.78-3.39c-3.79-4.36-15.7-19.47-13-34.5a21.91,21.91,0,0,0-9.85-3.11C669.06,1769.3,673.8,1779.49,688.78,1797.36Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M674,1773.66c1.2,3.56,3.31,6,4.71,5.58s1.55-3.74.35-7.3-3.32-6-4.72-5.57S672.82,1770.11,674,1773.66Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.68 1559.46 481.15 1558.91 481.13 1559.69 480.18 1560.21 479.68 1559.46",
    fill: "#f49b42"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.99 1572.24 485.77 1571.66 483.65 1571.62 483.99 1572.24",
    fill: "#e7365e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M675.22,1773.26c1.2,3.55,3.31,6,4.71,5.57s1.55-3.74.35-7.29-3.32-6-4.72-5.58S674,1769.7,675.22,1773.26Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M648.24,1733.72l-2.81.36a9.64,9.64,0,0,0-8.59,10.52l.92,7.38a9.65,9.65,0,0,0,10.93,8.07l2.81-.35Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#00666b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735,1730.27c2.52,20.16-.06,37.07-5.77,37.79s-12.4-15-14.93-35.19.06-37.07,5.77-37.79S732.47,1710.12,735,1730.27Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.75 1512.43 526.59 1516.73 528.07 1528.53 520.6 1537.24 515.76 1522.25 517.75 1512.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.3,1732.87c-2.12-16.94-.63-31.55,3.29-36.22l0,0c-31.18,29-70.93,37.56-70.93,37.56l3.23,25.76s54-9.87,76.55,7.23l0,0C721.49,1763.61,716.43,1749.82,714.3,1732.87Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#053c5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.86,1729.51c.41,3.27.24,6-.37,6.07s-1.46-2.52-1.87-5.79-.24-6,.38-6.07S722.45,1726.24,722.86,1729.51Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffd147"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M689.93,1788.83c-.85.31-3.8,2.17-13.35,2.17-7,0-10.08-8.54-11.26-13.18-.42-1.64-.79-4,1.25-5l11.17-1.55Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2303.05,1783.18a22.8,22.8,0,0,1,1,16.25l-3,21.09-3.62,2.44-13.49,5.57a14.54,14.54,0,0,0,0-8.45l-5.92-21.81s-9.21-36.81,15.78-35.24c-.12-30,8.23-25,8.23-25l.58,25.92Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365.24,1856.09s-17.47,66.68-32.38,67.87-30.39-105.63-30.39-105.63l-20.27,2.44s-7.87,153.63,37.58,156.43,51.46-31.18,51.46-31.18Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffe97d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.14,2038.41h118.91V1857.8c-34-51.84-76.31-37.72-76.31-37.72s-38.5.69-44.5,36C2365.24,1881.64,2367.14,2038.41,2367.14,2038.41Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f6a505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423.63,1796.09l1.76,25.54-.83.79a22.14,22.14,0,0,1-30.08.42h0l-.4-19.21Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f39f85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2433,1742.75l-2.15,42.2c-4.2-.16-6.66,4.34-5.86,8.29a7.85,7.85,0,0,0-.7,3.11c-7.29,5.22-20.54,12-37.61,8.76-26.71-5.11-10.59-56.75-10.59-56.75Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446.4,1774.45c.2-3.1,4.42-9.66,6.77-11.69,15.12-13.08,1.59-22.62-3.21-25.7-5.3-3.41-4.26-13-11.13-18.42-10.5-8.21-20.61.3-27.33-.94s-10.89-10.18-20.66-5.45-8.69,12.41-11.82,15.64-8.88-5.71-18.41,4.51c-14.5,15.54,13.93,22.19,13.93,22.19s15.56,6.44,36.15-1.64a6.76,6.76,0,0,1,8,2c4.92,6.73,5,41.94,5,41.94l6.87-5.72S2445.49,1788.63,2446.4,1774.45Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430.38,1777.91a6.48,6.48,0,1,1-3.55-8.46A6.49,6.49,0,0,1,2430.38,1777.91Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2394.09,2378.94s-6.7,9.27-38.29,17.32c-7,1.77-14.46,3-14.46,14.45h31.19l31.88-5.51v5.51h17.22s4.8-28.16-5.26-31.77Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392.45,2358.71l1.64,20.23h0a19.49,19.49,0,0,0,21.1.7l1.18-.7v-20.23Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2482.67,2378.94s-6.7,9.27-38.29,17.32c-7,1.77-14.45,3-14.45,14.45h31.18l31.88-5.51v5.51h17.23s4.79-28.16-5.27-31.77Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2481,2358.71l1.63,20.23h0a19.49,19.49,0,0,0,21.1.7l1.18-.7v-20.23Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2486,1857.8s35.64,82.26-9.83,124.28S2368.93,2017,2368.93,2017v-23.7s55.8-4.71,73.68-42-7.15-69.59-7.15-69.59",
    transform: "translate(-194.41 -207.05)",
    fill: "#f6a505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372.57,2013.7l-28.47.6c-11.56-.64-19.25-17.9-21.17-30.73a2.61,2.61,0,0,1,3.45-2.82c9.66,3.35,34.51,12.15,40.93,16.14Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.14,2038.41c-35.47,100.13,20,321.86,20,321.86h31.6s-14.91-314.41,26.22-321.86Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2449,1926.35a64.14,64.14,0,0,1-6.35,24.88c-17.88,37.31-76.59,42.25-76.59,42.25v23.93s64.64,6.69,110.12-35.33c16.48-15.24,22.28-35.76,23-55.73Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffda71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2448.68,1930c1.25-.57,2.51-1.11,3.74-1.7,2.14-27.56-14-48.35-14.18-48.61l-2.81,2.23C2435.63,1882.13,2451.69,1902.86,2448.68,1930Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f08712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.59,1786.35s6.56-2,7.59-13.94,6.68-8.27,6.68-8.27-2.94,47.19-10.46,49S2297.59,1786.35,2297.59,1786.35Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402.11,2038.41c-9.66,122.78,68.74,321.86,68.74,321.86h37.55s-25.52-127.3-26-246.77a639,639,0,0,1,3.69-75.09Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#053c5e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2016.87,2391.65s-10.1,9.37-33.12,15.23c-5.07,1.29-10.53-.43-10.53,7.93h27.93l23.24-4v4h12.55s3.49-20.52-3.84-23.16Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2018.28,2376.91l-1.41,14.74h0a14.18,14.18,0,0,0,15.37.52l.86-.52,5.22-14.74Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2128.52,2391.65s-10.09,9.37-33.11,15.23c-5.07,1.29-10.54-.43-10.54,7.93h27.94l23.24-4v4h12.54s3.5-20.52-3.83-23.16Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2129.94,2376.91l-1.42,14.74h0a14.2,14.2,0,0,0,15.38.52l.86-.52,5.21-14.74Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1866.95 1800.9 1834.81 1800.9 1823.52 2173.39 1845.24 2173.39 1909.04 1870.22 1866.95 1800.9",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1856.53 1800.9 1931.65 2173.39 1955.56 2173.39 1945.76 1800.9 1856.53 1800.9",
    fill: "#053c5e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2116.21,2089.84l7.2-.51a12.66,12.66,0,0,1,3.35-8.77c2.79-2.84,7.27-4.28,13.32-4.28,6.63,0,11.6,1.46,14.37,4.24a8.62,8.62,0,0,1,2.63,6.06l7.22.41a15.29,15.29,0,0,0-4.49-11.12c-4.22-4.33-10.86-6.52-19.73-6.52-8.18,0-14.46,2.2-18.67,6.55A19.34,19.34,0,0,0,2116.21,2089.84Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2085.46,
    y: 2098.22,
    width: 107.57,
    height: 69.21,
    transform: "translate(4084.08 4058.6) rotate(180)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2135.31,2144.87c0,4.22,2,4.7,4.49,4.7s4.49-.48,4.49-4.7v-14.68c31-3.23,48.74-8.73,48.74-8.73v54.59c0,4.88-1.89,8.83-4.75,8.83h-98.06c-2.87,0-4.76-4-4.76-8.83v-54.41c22.46,5.21,23.92,5.32,49.85,8.44Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#ffda71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2107.15,2126.31c5,9.75,10.18,19.3,16.69,28.2a306.86,306.86,0,0,0,25.77,30.37h-59.39c-2.87,0-4.76-4-4.76-8.83v-54.41C2095.56,2124,2101.41,2125.29,2107.15,2126.31Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f6a505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090.22,2083.37h98.06c2.86,0,4.75,4,4.75,8.83v26.48a166.35,166.35,0,0,1-48.74,8.28v-3.58c0-4.22-2-4.7-4.49-4.7s-4.49.48-4.49,4.7V2127c-29.35-.76-49.85-8.27-49.85-8.27V2092.2C2085.46,2087.32,2087.35,2083.37,2090.22,2083.37Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2133.91,2138.53V2134a2,2,0,0,1,2-1.95h7.78a2,2,0,0,1,2,1.95v4.55a2,2,0,0,1-2,1.94h-7.78A1.94,1.94,0,0,1,2133.91,2138.53Zm2-5.94a1.39,1.39,0,0,0-1.39,1.39v4.55a1.39,1.39,0,0,0,1.39,1.39h7.78a1.39,1.39,0,0,0,1.39-1.39V2134a1.39,1.39,0,0,0-1.39-1.39Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2139.25,2135.74a.48.48,0,0,0,.5.46h0a.49.49,0,0,0,.5-.46v-6.35a.49.49,0,0,0-.5-.47h0a.48.48,0,0,0-.5.47Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1874.62,1952.56c-1.11.89-5.22,3.57-15.18,4.4-8.94.74-28-3.15-24.35,5.68,8.57,4.62,18.06,11.07,18.06,11.07,5.46,2.29,15.12-.08,20.86-2.71l16.68-10.18s1.43-9.37,1.58-9.8l-3.82-1.56A45.77,45.77,0,0,1,1874.62,1952.56Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.56,1956.5a7.59,7.59,0,0,1-1,1.07c1.19.48,2.33,1,3.45,1.58,4.68.13,9.36.4,14,.58-.29-2.7-.69-6.49-.67-6.77l-30.41-7.24s-2.46,3.21,3.1,6.65A31.09,31.09,0,0,0,1871.56,1956.5Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2135.1,2051.3,2125,2073.52s2.18,12.22,6.65,17a4.77,4.77,0,0,0,5.29,1.07c4.21-1.74,13.93-6,15.54-8.26a4.56,4.56,0,0,0,.49-4l-2.94-9.79-.36-22.82Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1881.17 1577.02 1880.83 1606.8 1907.36 1605.37 1909.04 1559.2 1881.17 1577.02",
    fill: "#f39f85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.16,1786.81c-3.71-.1-7.15-.65-8.94-2.12-10.7-15.55,1.48-57.47,1.48-57.47l17.09-7.2,21.72,13.55,1.24,28.09a22.8,22.8,0,0,1-9.7,19.38h0A44.43,44.43,0,0,1,2071.16,1786.81Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2096.48,1749.49c-1.19-4.72,2-15.61-2.77-14.82-3.5.57-15.51,1.07-19.56,1.07-9.63,0-26.8-3.77-26.8-18.43,0-7.33,4.5-11,9-12.92s9.4,3.46,13.92,5c10.61,3.7,32.5,6.71,38.11,5.55,6.36-1.32,13,5.17,13.51,9,1.07,8.5-4.62,21.45-8.83,29.63a44.77,44.77,0,0,1-9.62,12.59h0Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#212b53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2108.85,1750.55c-2.14-1.9-6.16-1.54-9,.8s-3.35,5.77-1.2,7.67,6.16,1.53,9-.8S2111,1752.45,2108.85,1750.55Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#f7b58e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2089.35,1804.5a76.44,76.44,0,0,1,31.14,6.38c21.41,9.43,36.58,29,42,51.82,8.43,35.85,22.59,120.9-9.86,195.45a161.26,161.26,0,0,1-21.72,0l-3.47-175.75,2.46,125.54H2029.23v-81s-2.61,18.29-26.93,35.17-115.54,5.66-115.54,5.66v-19s79.92-16.8,93-26.68,41.17-81.13,41.17-81.13a64.31,64.31,0,0,1,44-34.16A121,121,0,0,1,2089.35,1804.5Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#01888b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1934.04 1801.59 1931.67 1680.62 1934.28 1680.54 1936.67 1801.59 1934.04 1801.59",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1907.87 1588.97 1909.5 1598.75 1879.01 1598.69 1881 1588.97 1907.87 1588.97",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2243.76 829.3 2261.86 864.9 2223.84 856.23 2093.8 815.25 2243.76 829.3",
    fill: "#afd8c7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2261.86 864.9 2197.28 860.89 2213.1 852.84 2261.86 864.9",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2243.76 829.3 2255.06 794.61 2093.8 815.25 2243.76 829.3",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2093.8 815.25 2223.84 856.23 2204.46 906.22 2093.8 815.25",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-2)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2442,1107.77a3.12,3.12,0,0,0,.92-.71,3,3,0,0,0-.3-4.29,85.84,85.84,0,0,0-12.78-9.21,3,3,0,0,0-3.08,5.24,77.94,77.94,0,0,1,11.87,8.56A3,3,0,0,0,2442,1107.77Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2394.75,1439.77a3,3,0,0,1,1.07-4.16,85.44,85.44,0,0,0,22.28-19.31,3,3,0,1,1,4.69,3.87,91.74,91.74,0,0,1-23.88,20.67.91.91,0,0,1-.17.09A3,3,0,0,1,2394.75,1439.77Zm34.62-34.06a3,3,0,0,1-1.14-4.14,108.92,108.92,0,0,0,11-27.65,3,3,0,1,1,5.9,1.46,114.61,114.61,0,0,1-11.64,29.19,3,3,0,0,1-1.26,1.2A3,3,0,0,1,2429.37,1405.71Zm15.47-46.2a3,3,0,0,1-2.82-3.24l.09-1.37a140.66,140.66,0,0,0-1.49-28.56,3,3,0,0,1,6-.91,146.31,146.31,0,0,1,1.56,29.8l-.09,1.47a3,3,0,0,1-3.25,2.81Zm-4.22-48.68a3,3,0,0,1-3.71-2.16,220.71,220.71,0,0,0-9.86-28.6,3,3,0,1,1,5.6-2.35,225.35,225.35,0,0,1,10.13,29.39,3,3,0,0,1-1.56,3.48A2.89,2.89,0,0,1,2440.62,1310.83Zm-17.08-46a3,3,0,0,1-4.06-1.39l-1.14-2.29a101.8,101.8,0,0,1-9.82,3.27,3,3,0,1,1-1.63-5.85c2.94-.81,5.83-1.77,8.67-2.86-3.16-6-6.63-12.32-10.56-19.08a3,3,0,1,1,5.25-3.05c4.07,7,7.67,13.5,10.93,19.77a92.23,92.23,0,0,0,12.65-7.06,3,3,0,0,1,3.37,5.05,97.47,97.47,0,0,1-13.26,7.42l1,2a3,3,0,0,1-1.35,4Zm24-25.56a3,3,0,0,1-.06-4.3,76,76,0,0,0,16.12-24.52,3,3,0,1,1,5.62,2.31,82,82,0,0,1-5.43,10.9,83.85,83.85,0,0,1-11.95,15.55,3.24,3.24,0,0,1-.8.59A3.05,3.05,0,0,1,2447.54,1239.31Zm-57.67,28.52a94.76,94.76,0,0,1-31.46-2.46,3,3,0,1,1,1.49-5.89,88.58,88.58,0,0,0,29.45,2.29,3,3,0,0,1,1.63,5.74A3.11,3.11,0,0,1,2389.87,1267.83ZM2471,1197a3.05,3.05,0,0,1-2.47-3.52,91.91,91.91,0,0,0,.28-29.58,3,3,0,0,1,6-.9,98.56,98.56,0,0,1-.3,31.53,3,3,0,0,1-1.62,2.18A3.05,3.05,0,0,1,2471,1197Zm-130.39,61.69a79.29,79.29,0,0,1-7.13-4.13,64.85,64.85,0,0,1-17.17-16.4,3,3,0,1,1,4.93-3.55,58.91,58.91,0,0,0,15.55,14.86,72.42,72.42,0,0,0,6.59,3.81,3,3,0,0,1,1.32,4.09,3,3,0,0,1-1.32,1.32A3,3,0,0,1,2340.57,1258.67Zm55-37.63c-6.53-10.13-12.49-17.49-18.76-23.15a3,3,0,1,1,4.07-4.51c6.68,6,13,13.78,19.8,24.37a3,3,0,0,1-.91,4.2l-.27.15A3,3,0,0,1,2395.53,1221Zm72.87-72.6a3,3,0,0,1-3.86-1.89,96.66,96.66,0,0,0-5.28-12.48,92.89,92.89,0,0,0-8.54-13.71,3,3,0,1,1,4.85-3.65,98.33,98.33,0,0,1,9.11,14.61,103.34,103.34,0,0,1,5.61,13.26,3,3,0,0,1-1.5,3.69A2.3,2.3,0,0,1,2468.4,1148.44Zm-156.85,74.36a3,3,0,0,1-3.68-2.21c-2.16-8.63-1.3-17,2.49-24.22a30.77,30.77,0,0,1,5.19-7.14,3,3,0,1,1,4.35,4.24,24.42,24.42,0,0,0-4.16,5.73c-3.13,6-3.79,12.65-2,19.92a3,3,0,0,1-1.56,3.44A2.41,2.41,0,0,1,2311.55,1222.8Zm50.79-34.69a43.51,43.51,0,0,0-28-2.64,3,3,0,1,1-1.49-5.89,49.12,49.12,0,0,1,32,3,3,3,0,1,1-2.54,5.52Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2381.6,1448.36a3,3,0,0,0-2.21-5.63,65.52,65.52,0,0,1-14.28,2.41,3,3,0,1,0,.33,6.06,71.56,71.56,0,0,0,15.62-2.62A3.21,3.21,0,0,0,2381.6,1448.36Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "737.09 595.79 631.94 537.76 578.26 527.02 537.7 532.98 737.09 595.79",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-3)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "737.09 595.79 540.19 545.17 537.7 532.98",
    fill: "#afd8c7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.57 578.96 534.83 579.37 543.09 609.93 736.59 595.8 534.57 578.96",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.98 561.04 525.07 538.24 735.81 595.46 554.4 590.07 496.98 561.04",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_2-4)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.5,1158.19a146.29,146.29,0,0,0,18.94-8.22,2.86,2.86,0,1,1,2.64,5.08,153.77,153.77,0,0,1-19.68,8.54c-2.42.85-4.86,1.65-7.3,2.38a2.86,2.86,0,1,1-1.65-5.48Q245,1159.43,248.5,1158.19Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.86,746.77c8.92,1.15,18.22,2.61,28.4,4.5a2.86,2.86,0,1,1-1,5.62c-10.09-1.86-19.28-3.31-28.1-4.44a3,3,0,0,1-1.34-.54,2.86,2.86,0,0,1,2.07-5.14Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.14,749a2.87,2.87,0,0,1,1.68-5.16c9.18-.08,18.89.3,28.84,1.14a2.86,2.86,0,0,1-.48,5.7c-9.78-.82-19.3-1.2-28.31-1.12A2.84,2.84,0,0,1,586.14,749Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.7,1123.71a2.81,2.81,0,0,1,4,0,2.86,2.86,0,0,1-.05,4,160.3,160.3,0,0,1-22.58,18.34,2.85,2.85,0,0,1-3.29-.08,2.71,2.71,0,0,1-.68-.71,2.85,2.85,0,0,1,.78-4A154.56,154.56,0,0,0,303.7,1123.71Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,1115.33a2.86,2.86,0,0,1-.4-4q2.43-3,4.71-6a148.66,148.66,0,0,0,11-17.19,2.86,2.86,0,0,1,3.88-1.14,2.89,2.89,0,0,1,1.15,3.88,153.17,153.17,0,0,1-11.42,17.85q-2.36,3.19-4.88,6.26a2.85,2.85,0,0,1-3.91.49Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.56,1076.6a2.88,2.88,0,0,1-1.55-3.73,195.69,195.69,0,0,0,8.7-26.78,2.86,2.86,0,0,1,5.55,1.4,200.54,200.54,0,0,1-9,27.55A2.86,2.86,0,0,1,339.56,1076.6Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,832.52q-3.57,4.37-6.93,8.89c-3.37,4.55-6.59,9.26-9.57,14a2.85,2.85,0,0,1-3.94.9l-.19-.12a2.87,2.87,0,0,1-.71-3.82c3.05-4.87,6.36-9.71,9.82-14.38q3.44-4.63,7.1-9.11a2.73,2.73,0,0,1,4-.4A2.86,2.86,0,0,1,415.41,832.52Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.48,870.11a208.86,208.86,0,0,0-11.34,25.81,2.85,2.85,0,0,1-3.66,1.72,2.69,2.69,0,0,1-.73-.39,2.85,2.85,0,0,1-1-3.26,214.63,214.63,0,0,1,11.65-26.53,2.86,2.86,0,1,1,5.07,2.65Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.36,800.63a232.57,232.57,0,0,0-20.71,19.2,2.85,2.85,0,0,1-3.77.33,3.11,3.11,0,0,1-.28-.23,2.86,2.86,0,0,1-.09-4,238.23,238.23,0,0,1,21.21-19.69,2.87,2.87,0,0,1,3.64,4.43Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.1,768.07a2.84,2.84,0,0,1-2.86-.31,2.9,2.9,0,0,1-.92-1.15,2.86,2.86,0,0,1,1.46-3.77,227.43,227.43,0,0,1,27.17-10,2.86,2.86,0,0,1,1.63,5.49A220,220,0,0,0,500.1,768.07Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,987.53a2.88,2.88,0,0,1-2.52-3.17l.41-3.6c.95-8.29,1.89-16.59,3-24.86a2.86,2.86,0,1,1,5.67.75c-1.09,8.24-2,16.5-3,24.76l-.41,3.6A2.87,2.87,0,0,1,359.15,987.53Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.84,790.35a2.86,2.86,0,1,1-3.29-4.67,235.93,235.93,0,0,1,24.62-15.21,2.86,2.86,0,0,1,2.7,5A231,231,0,0,0,460.84,790.35Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,998.9a2.84,2.84,0,0,1,2.48,3.19c-1.41,11.15-2.79,20.19-4.34,28.46a2.86,2.86,0,0,1-5.63-1.06c1.54-8.15,2.9-17.09,4.3-28.11A2.85,2.85,0,0,1,357.81,998.9Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.07,1164.52a2.86,2.86,0,0,1,1.1,5.61,230.75,230.75,0,0,1-28.69,3.71,2.87,2.87,0,0,1-3.06-2.65,2.87,2.87,0,0,1,2.65-3.06A227.29,227.29,0,0,0,225.07,1164.52Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.08,908.57a2.86,2.86,0,0,1,2,3.51c-2.25,8.41-4.18,17.47-5.9,27.69a2.85,2.85,0,0,1-3.29,2.35,2.94,2.94,0,0,1-1.23-.52,2.88,2.88,0,0,1-1.12-2.77c1.74-10.41,3.71-19.64,6-28.23A2.86,2.86,0,0,1,372.08,908.57Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.46,745.5c3.34-.4,6.69-.72,10-1a2.86,2.86,0,1,1,.43,5.71q-4.89.36-9.78.95c-6,.71-12.15,1.72-18.15,3a2.83,2.83,0,0,1-2.29-.5,2.86,2.86,0,0,1,1.11-5.1C548,747.27,554.25,746.24,560.46,745.5Z",
    transform: "translate(-194.41 -207.05)",
    fill: "#63c0c4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTips);
export default __webpack_public_path__ + "static/media/card-tips.a2d78620ba1420e4de322c6e3162e462.svg";
export { ForwardRef as ReactComponent };